import React, { useState } from "react";
import "./style.scss";
import CommonButton from "../commonButton";
import WarningIcon from "../../assets/images/timekeeping_icons/warning_icon.svg";
import moment from "moment";
// import Tooltip from "rc-tooltip";
// import "rc-tooltip/assets/bootstrap.css";
import SortIcon from "../../assets/images/debit_report/expand_all.svg";

const DebitTable = ({
  tableData,
  handleExport,
  csvLoading,
  pdfLoading,
  sortOrder,
  setSortOrder,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleSort = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };
  const sortedTableData = tableData.sort((a, b) => {
    const dateA = moment(a.payment_date).format("YYYY-MM-DD");
    const dateB = moment(b.payment_date).format("YYYY-MM-DD");
    if (sortOrder === "asc") {
      return dateA.localeCompare(dateB);
    } else {
      return dateB.localeCompare(dateA);
    }
  });
  const startIndex = currentPage * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const totalPages = Math.ceil(tableData.length / rowsPerPage);
  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(0);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
    // navigate(
    //   `?frequency=${selectTagValue.id}&page=${page}&status=${ptoStatus}`
    // );
  };
  return (
    <div className="debit-listing-wrapper">
      <div className="debit-list-title-wrapper">
        <h5>Debit Listing</h5>
        <div className="list-table-btn-wrapper">
          <CommonButton
            variant="primary"
            onClick={
              csvLoading || pdfLoading ? null : () => handleExport("csv")
            }
            btnText="Export to csv"
            isLoading={csvLoading}
            fontWeight="400"
          />
          <CommonButton
            variant="secondary"
            onClick={
              pdfLoading || csvLoading ? null : () => handleExport("pdf")
            }
            btnText="Export to pdf"
            isLoading={pdfLoading}
          />
        </div>
      </div>
      <div className="pto-table-container">
        <div className="pto-table-scroll">
          {sortedTableData && sortedTableData?.length > 0 ? (
            <table className="pto-table">
              <thead>
                <tr>
                  <th
                    style={{ width: "15%", textAlign: "left" }}
                    onClick={handleSort}
                    className="pointer-cus"
                  >
                    Payment Date <img src={SortIcon} alt="sort-icon" />
                  </th>
                  <th style={{ width: "20%", textAlign: "left" }}>
                    Transaction Type
                  </th>
                  <th style={{ width: "20%", textAlign: "left" }}>
                    Payment Event Type
                  </th>
                  <th style={{ width: "25%", textAlign: "left" }}>
                    Pay Period
                  </th>
                  <th style={{ width: "20%", textAlign: "left" }}>Amount</th>
                </tr>
              </thead>
              <tbody>
                {tableData.slice(startIndex, endIndex).map((row, index) => (
                  <tr key={`payment-${index}`}>
                    <td>{moment(row.payment_date).format("MM/DD/YYYY")}</td>
                    <td>{row?.transaction_type}</td>
                    <td>{row.payment_event_type}</td>
                    <td>{`${moment(row.start_date).format(
                      "MM/DD/YYYY"
                    )} - ${moment(row.end_date).format("MM/DD/YYYY")}`}</td>
                    <td>${row.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="no-data-text">
              <img src={WarningIcon} alt="warning" />
              <h5>No Data Found</h5>
            </div>
          )}
        </div>
        {tableData.length > 10 && (
          <div className="d-flex justify-content-between py-3 px-3">
            <div>
              <select value={rowsPerPage} onChange={handleRowsPerPageChange}>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={30}>30</option>
                <option value={50}>50</option>
              </select>
            </div>
            <div>
              {currentPage !== 0 && (
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  className="non-active-pagination-btn"
                >
                  &lt;
                </button>
              )}
              {Array.from({ length: totalPages }, (_, i) => i).map((page) => (
                <button
                  key={page}
                  disabled={currentPage === page}
                  onClick={() => handlePageChange(page)}
                  className={
                    currentPage === page
                      ? "active-pagination-btn "
                      : "non-active-pagination-btn"
                  }
                >
                  {page + 1}
                </button>
              ))}
              {currentPage !== totalPages - 1 && (
                <button
                  disabled={currentPage === totalPages - 1}
                  onClick={() => handlePageChange(currentPage + 1)}
                  className="non-active-pagination-btn"
                >
                  &gt;
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DebitTable;
